import React from 'react';
import cn from 'classnames';
import { useDispatch } from 'react-redux';
import Icon from '../../../../../../components/common/icon';
import { Visibility, SectionType } from '../../../../../../types/common-types';
import { updateItemRequest } from '../../../../../../store/page/actions';

import './style.scss';

interface SectionProps {
  id?: string;
  formId?: string;
  headerItems: React.ReactNodeArray;
  contentItems: React.ReactNodeArray;
  hideSectionHeader: boolean;
  hideSectionContent: boolean;
  visibility?: Visibility;
  type?: SectionType;
  style?: object;
}

const Section: React.FC<SectionProps> = ({
  id,
  formId,
  headerItems,
  contentItems,
  visibility,
  hideSectionHeader,
  hideSectionContent,
  type = SectionType.Body,
  style,
}) => {
  const dispatch = useDispatch();
  const handleModalClose = () => {
    dispatch(
      updateItemRequest({
        item: [{ id, visibility: Visibility.Hidden }],
        formId,
      })
    );
  };
  return (
    <div
      id={id}
      data-cy="section"
      styleName={cn('section', {
        hidden: visibility === Visibility.Hidden,
        block: type === SectionType.Block,
        modal: type === SectionType.Modal,
      })}
    >
      <div styleName="section__wrap">
        {type === SectionType.Modal ? (
          <div styleName="section__close">
            <div
              role="button"
              tabIndex={visibility === Visibility.Visible ? 0 : -1}
              onClick={handleModalClose}
              onKeyPress={handleModalClose}
            >
              <Icon value="close" />
            </div>
          </div>
        ) : null}
        <div styleName={cn('section__header', { hidden: hideSectionHeader })}>
          {headerItems}
        </div>
        <div
          styleName={cn('section__content', { hidden: hideSectionContent })}
          style={style}
        >
          {contentItems}
        </div>
      </div>
    </div>
  );
};

export default Section;
